//{{-- ---------------------------------------------------------------------------------------------------------------------- --}}
//{{-- Originally written for the filedropform.blade.                                                                         --}}
//{{-- This script file can be used with any blade (or pair of blades) that want to enqueue and then upload files.            --}}
//{{--                                                                                                                        --}}
//{{-- The first blade will have a file-drop and/or input field, and will enqueue the files for later uploading.              --}}
//{{-- This blade must:                                                                                                       --}}
//{{--   1. Push to head the necessary blueimp JQuery File Upload js assets:                                                  --}}
//{{--        @push('head')                                                                                                   --}}
//{{--        <script src="{{asset('js/jquery.ui.widget.js')}}"></script>                                                     --}}
//{{--        <script src="{{asset('js/jquery.iframe-transport.js')}}"></script>                                              --}}
//{{--        <script src="{{asset('js/jquery.fileupload.js')}}"></script>                                                    --}}
//{{--        @endpush                                                                                                        --}}
//{{--   2. Have an optional "fileboxdiv" div that will get a dark border on mouseover                                           --}}
//{{--   3. Have a div and/or a file field with class "fileupload" where files can be dropped/selected for uploading          --}}
//{{--   4. Have an optional div with id="filebox_*" that will call a method called fileBoxClickCallback() upon being clicked --}}
//{{--      (3 and 4 can be the same div)                                                                                     --}}
//{{--   5. Push a text variable and this script:                                                                             --}}
//{{--        @push('scripts')                                                                                                --}}
//{{--              <script> var fdf_file_greater_2_gb = "{{__('file_greater_1_gb')}} "; </script>                            --}}
//{{--              <script> var fdf_storeTypeArr = {"original" : "{{config('filesystems.store_original')}}", "working" : "{{config('filesystems.store_working')}}", "supportmat" : "{{config('filesystems.store_supportmat')}}"}; </script> --}}
//{{--              <script src="{{mix('js/my.filedropform.scripts.js')}}"></script>                          --}}
//{{--        @endpush                                                                                                        --}}
//{{--   6. Implement (somewhere) the following js callback methods:                                                          --}}
//{{--      fileBoxClickCallback()  (optional  - to do whatever needs to be done when the filebox_* is clicked)               --}}
//{{--      fileUploadAddCallback(see parms) (mandatory - to process the file thats been enqueued, and add it to a docArr)    --}}
//{{--                                                                                                                        --}}
//{{-- The second blade will trigger the actual file upload (could be the same blade).                                        --}}
//{{-- This blade must:                                                                                                       --}}
//{{--   1. Prepare the FTP parameters to define where the uploaded files will go                                             --}}
//{{--   2. Have the following ready to show the progress bar:                                                                --}}
//{{--      a div with id = "progress-div"                                                                                    --}}
//{{--      a field in that div with id="progress-fname" to show the file name being uploaded                                 --}}
//{{--      an empty div with class="progress-bar" to display the progress bar                                                --}}
//{{--   3. Call uploadFiles in here, passing it the docArr and the FTPParms                                                  --}}
//{{--   4. Implement the following js callback methods:                                                                      --}}
//{{--      uploadDoneCallback(fileNbr, resultFile, fileSize, callerId) - to do whatever needs to be done after each file is uploaded   --}}
//{{--      $('body').safeOn('myUploadErrorEvent', function (evt, type, fname, errorMsg, callerPrefix) - to handle upload errors  --}}
//{{--      NOTE: FOR THE JMS THESE ARE IMPLEMENTED IN my.jobfileuploadcallbacks.script.js                                    --}}
//{{--                                                                                                                        --}}
//{{-- So, ESSENTIALLY: we separate the upload from the database operations. Upload goes first, puts the file where it        --}}
//{{-- needs to be (S3 or local). We get notifed that the upload completed without errors by the fileuploaddone callback,     --}}
//{{-- which calls our uploadDoneCallback(), where we (a) if using S3, copy the file to local disk, (b) trigger the database  --}}
//{{-- store function.                                                                                                        --}}
//{{--                                                                                                                        --}}
//{{-- ---------------------------------------------------------------------------------------------------------------------- --}}

//{{-- -------------------------------------------------------------- --}}
//{{-- Global variables start with fdf_                               --}}
//{{-- -------------------------------------------------------------- --}}        
var fdf_maxFileSize = 3221225472; //{{-- 3 GB --}}
var fdf_TotalFilesBytes = 0;
var fdf_TotalBytesLoaded = 0;
var fdf_filenamesOriginal = [];                                                                 //{{-- this will be used in upload() to avoid adding usr/time prefix to filenames more than once (may happen when upload fails and user tries again)--}}
var fdf_bytesArr = [];

//{{-- -------------------------------------------------------------- --}}
//{{-- Prevent default "document drop" action anywhere on the page    --}}
//{{-- -------------------------------------------------------------- --}}      
jQuery(document).on('drop dragover', function (e) {
    e.preventDefault();
});

//{{-- ----------------------------------------------- --}}
//{{-- Handle hovering and clicking on the file boxes  --}}
//{{-- ----------------------------------------------- --}}
$(function(){
    $('.fileboxdiv').safeOn({
        mouseenter: function () {
            $(this).addClass('bg-dark');
        },
        mouseleave: function () {
            $('.fileboxdiv').removeClass('bg-dark');
        }
    }).on('dragover', function () {
        $(this).addClass('bg-dark');
    }).on('dragleave', function () {
        $('.fileboxdiv').removeClass('bg-dark');
    });

    $('[id^=filebox_]').safeOn('click',function (evt) {  //{{-- Processes a click on the file box  --}}                  
        evt.stopImmediatePropagation();          //{{-- Prevent click event triggering once for every parent container --}}
        fileBoxClickCallback();                  //{{-- Call back to process the click on the file box --}}
    });

    //{{-- ------------------------------------------------------------------------------------------------------------------------------------------------ --}}
    //{{-- Scripts to handle file uploading                                                                                                                 --}}
    //{{-- Basic blueimp "drop" and "upload" functions from https://www.sanwebe.com/2015/06/ajax-multi-file-upload-with-blueimp-php                         --}}
    //{{-- Important note about the input fields:                                                                                                           --}}
    //{{-- - they must have a class of "fileupload" or otherwise the 'var fi = ' definition must catch them in the jquery selector                          --}}
    //{{-- - they must have a name that is an array name, like "name[]"                                                                                     --}}
    //{{-- - the "name[]" is part of the data sent to the server, and it's under that name that the files will reside in the                                --}}
    //{{-- ... fileupload data structure for its callback functions - data.result.files is really data.result.name - and contains the returned relativepath --}}
    //{{-- ------------------------------------------------------------------------------------------------------------------------------------------------ --}}

    //{{-- Process the file inputs - note that we may have multiple  --}}
    var fi = $(".fileupload");

    //{{--Initialize blueimp fileupload plugin --}}
    fi.each(function () { //{{-- use .each to process the file inputs separately --}}
        $(this).fileupload({
            url: "", //{{-- we'll define url later, in projcreateform.blade or job_wkfsendfile.blade --}}
            type: "POST",
            dataType: 'html',
            autoUpload: false, //{{-- autoUpload = false means we're only adding files to the queue --}}
            acceptFileTypes: /(\.|\/)(gif|jpe?g|png|mp4|mp3|mov|wmv|doc?|xls?|ppt?|pdf|txt|zip|rar)$/i,
            multipart: true, //{{-- so enctype:"multipart/form-data" is not needed (or even a form) --}}
            dropZone: $(this), //{{-- specify page element for drop zone - If not used, defaults to whole document, but will result in multiple calls to fileuploadd every time a file is dropped. At one point I determined this was related to "cannot call methods on fileupload prior to initialization" error on the Admin page; but then I put class='fileupload' on the body of the internal.blade and eveyrthing seems to work. --}}
            replaceFileInput: false, //{{-- without this, a line in jquery.fileupload.js (input.after(inputClone).detach();) was deleting the content of the input field before the fileuploadadd (below) was run --}}
            paramName: "file",
            //{{--IMPORTANT: THE name OF THE INPUT FIELD IS SENT TO THE SERVER, IN OUR CASE "file" - we also specify it here as paramName - see blueimp doc --}}
            //{{--IMPORTANT: If we don't specify it here as paramName, the upload via the "select file" button works, via dropzone does not --}}
        });
    });

    //{{-- For each file upload that is submitted, we can prepare extra form content... like for AWS S3... --}}
    //fi.on('fileuploadsubmit', function (e, data) {
    //data.formData = {title: data.files[0].title};
    //});

    //{{-- Add the files to the queue (remember, "autoupload" is off, so this is just the queue) --}}
    //{{-- And remember that "data" returned from blueimp's fileupload will contain all initialization data, including the target route --}}
    fi.on('fileuploadadd', function (e, data) {
        //{{-- Loop though each file in data - since this fi.on() gets called once for each file, there's always only one file in data --}}
        fcount = data.originalFiles.length;
        $.each(data.files, function (index, file) {
            //{{-- First, check file size --}}
            if (file.size > fdf_maxFileSize) {
                alert(fdf_file_greater_3_gb + file.name);
                //{{--fi.fileupload('option', 'destroy').call(fi, $.Event('destroy'), data);  // This was an attempt at removing the file from the queue, didn't work... --}}
            } else {
                //{{-- We got a file, make sure we have the right file type --}}
                var patt1 = /\.([0-9a-z]+)(?:[\?#]|$)/i;
                var ext = file.name.match(patt1)[1];
                var ft = { doc: 3, docx: 3, txt: 3, pages: 3, ppt: 5, pptx: 5, key: 5, xls: 6, xlsx: 6, xlsm: 6, numbers: 6, pdf: 2, mp3: 8, wav: 8, mp4: 7, mov: 7, wmv: 7, avi: 7 }  //{{-- TODO: File types are hardcoded here! --}}
                var fileType = ft[ext.toLowerCase()];
                if (typeof fileType === 'undefined') fileType = 1; //{{-- 1 = "other" --}}
                //{{-- Process the file --}}
                fileUploadAddCallback(fcount, -1, null, file.name, fileType, file.size, data);
            }
        });
    });

    //{{-- Updates the progress div for each file  --}}
    //{{-- In order for this to work, we have to use a separate line/bar per file, because files are uploaded in parallel --}}
    //{{--fi.on('fileuploadprogress', function (e, data) { --}}
    //{{--    var fp = parseInt(data.loaded / data.total * 100, 10); --}}
    //{{--    var fn = data.files[0].name; --}}
    //{{--    var fs = data.files[0].size; --}}
    //{{--    $("#progress-div > #progress-fname").html("Uploading: " + "<span>" + fn + " (" + fp + "%) " + "</span>" ); --}}
    //{{--});  --}}

    //{{-- Updates the overall progress bar - progress-div, progress-fname and progress-bar are presumed to exist in the doc --}}
    //{{-- fileuploadprogressall returns data.loaded and data.total - but if files were given to fileupload separately, they will be reported here separately as well, so we need to use fdf_TotalFilesBytes --}}
    //{{-- In other words, fileuploadprogressall DOES NOT WORK, it keeps reporting not the All value, but each file's value in turn - but it doesn't tell us which file it is --}}
    //{{-- But fileuploadprogress does tell us which file (it's always files[0]) the loaded and total numbers are for... --}}
    //{{-- So we must work with fileuploadprogress and keep track of the different files and the total ourselves: --}}
    fi.on('fileuploadprogress', function (e, data) {
        var fnbr = data.files[0].filenbr;
        fdf_TotalBytesLoaded += data.loaded;        
        if (fdf_bytesArr[fnbr] != undefined) fdf_TotalBytesLoaded -= fdf_bytesArr[fnbr];
        fdf_bytesArr[fnbr] = data.loaded;
        var percentprg = parseInt(fdf_TotalBytesLoaded / fdf_TotalFilesBytes * 100, 10);
        $("#progress-div").show();
        $(".progress-bar").attr('aria-valuenow', percentprg).css('width', percentprg + '%').text(percentprg + '%' + " (" + fdf_TotalBytesLoaded + "/" + fdf_TotalFilesBytes + ")");
    });

    //{{-- Handles upload failure - remember we are submitting ONE file at a time --}}
    fi.on('fileuploadfail', function (e, data) {
        $.each(data.files, function (index, file) { //{{-- loop though each file - should only be ONE --}}
            msg = "";
            if (data.textStatus == "error") msg = msg + "Error uploading file." + "<br />";
            if (data.errorThrown) msg = msg + data.errorThrown + "<br />";
            if (data.jqXHR && data.jqXHR.responseText) msg = msg + data.jqXHR.responseText + "<br />";
            if (msg) {
                $('body').trigger("myUploadErrorEvent", ["file", file.name, msg, data.callerPrefix]);
            }
        });
    });

    //{{-- File upload DONE callback  - remember we are submitting ONE file at a time - this will be called for each one --}}
    //{{-- fileuploaddone gets called once per file and data ever only has one file --}}
    fi.on('fileuploaddone', function (e, data) {
        var fileNbr = data.files[0].filenbr;                                                    //{{-- get the file number we inserted, so we know which document this is --}}
        if (data.total < 2) {
            $('body').trigger("myUploadErrorEvent", ["file", data.files[0].name, fdf_upload_error_empty_file, data.callerPrefix]);
        } else {
            uploadDoneCallback(fileNbr, data.formData.key, data.files[0].size, data.jobData);   //{{-- uploadDoneCallback is where we do anything that needs to be done after the file is uploaded, like DATABASE stuff --}}
        }
    });
});

//{{-- This is a little method to clear the current file list, in case we get some leftover garbage --}}
function clearfileList() {
    $(".fileupload").find(".files").empty();
}

//{{-- Does the actual uploading of the files, by calling the blueimp file.upload method for each file --}}
//{{-- Uploads the files in docsArr.file.data ... to AWS S3 or whatever destination is defined in FTPParms --}}
//{{-- FTPParms is an array containing a url and an array of input parms - see the FilesController for the S3 example --}}
//{{-- storeType is "original", "working", or "supportmat" to indicate which disk should be used to store the file, as per ENV definitions; usually originals are stored in S3 (and copied to ipHotel), finals and working are stored in the local server (test or production) --}}
window.uploadFiles = function(docsArr, FTPParams, storeType, clearfdfFN) {
    if (notThere(clearfdfFN)) clearfdfFN = null;
    var timestamp = parseInt($.now()/1000);                                                 //{{-- Get timestamp --}}
    var disk = fdf_storeTypeArr[storeType];
    if (clearfdfFN) fdf_filenamesOriginal = [];

    //{{-- First we go through docArr and calculate the total bytes for all files --}}
    fdf_TotalFilesBytes = 0;
    $.each(docsArr, function(index, file) {
        if (file.validated && isThere(file.fileData)) {
            fdf_TotalFilesBytes += file.fileData.files[0].size;;                            //{{-- fdf_TotalFilesBytes is defined here and used in myfiledropform.script --}}
        }
    });
    //{{-- Now we process and upload each file --}}
    $.each(docsArr, function(index, file) {
        if (file.validated && isThere(file.fileData)) {
            //{{-- This is where the actual upload takes place --}}
            //{{-- Get all supporting data and parameters lined up... --}}
            file.fileData.files[0].filenbr = file.filenbr;                                  //{{-- Insert filenbr into the file data, so we can identify it on the uploaddone callback (trackUploads, below) --}}
            file.fileData.url = FTPParams.url;                                              //{{-- Get all parameters the file transfer parameters obtained with getFTParams() --}}
            file.fileData.formData = {};
            $.each(FTPParams['inputs'], function(name, value) {
                file.fileData.formData[name] = value;
            });
            file.fileData.jobData = {};
            $.each(FTPParams['jobData'], function(name, value) {
                file.fileData.jobData[name] = value;
            });
            file.fileData.formData['Content-Type'] = file.fileData.files[0].type;
            file.fileData.formData['Content-Length'] = file.fileData.files[0].size;

            //{{-- Grab original filename, if we don't have it yet (if there's an upload error and user tries again, we may rerun here) --}}
            if (!fdf_filenamesOriginal[index]) {
                fdf_filenamesOriginal[index] = file.filename;
            }
            //{{-- Make sure original file name isn't too long (truncate if more than 150 chars + extension) - and keep the language suffix (the last "_xxxxx" bit) --}
            //{{-- Just take the first 130 and the last 20 characters --}}
            fn_len = fdf_filenamesOriginal[index].length;
            if (fn_len > 150) {
                fn = fdf_filenamesOriginal[index];
                fdf_filenamesOriginal[index] = fn.substr(0, 128)  + "_" + fn.substr(fn_len-21, fn_len-1);
            }                
            //{{-- Prepare clean and qualified file names --}}
            //{{-- Note that on the client side, user_id can only be used for original files - for the others, it's a resource ID and not a customer user ID, so it must be resolved server-side --}}
            //{{-- This is where we specify the destination folder... and the numerical prefix for original files --}}
            filenameClean = removeDiacritics(fdf_filenamesOriginal[index]);                                     //{{-- Clean filename without userid or timestamp --}}
            filenameClean = filenameClean.replace(/ /g, "_");
            if (storeType == "original")
                filenameQualified = "storage/" + $("#user_id").val() + '/' + timestamp + "_" + filenameClean;
            if (storeType == "working") 
                filenameQualified = "storage/" + file.fileData.jobData['ownerId'] + '/temp/' + filenameClean;
            if (storeType == "supportmat") 
                filenameQualified = "supportmat/" + file.fileData.jobData['ownerId'] + '/' + filenameClean;
            if (storeType == "replacing") {
                filenameQualified = file.fileData.jobData['fullFN'];
                filenameClean = file.fileData.jobData['replaceFN'];
                fdf_filenamesOriginal[index] = filenameClean;
            }

            timestamp++;

            //{{-- Make sure the filenames are in docsArr, to be used later --}}
            docsArr[index].filename = filenameClean;
            docsArr[index].filenameOriginal = fdf_filenamesOriginal[index];
            docsArr[index].originalDisk = disk;

            //{{-- Put filename in file for submitting--}}
            file.fileStoreType = storeType;
            file.filename = filenameClean;
            file.fileData.formData['key'] = filenameQualified;

            //{{-- Submit the (ONE) file. The submit is defined in filedropform when we create the blueimp fileupload object --}}
            file.fileData.submit();
        }
    });
}